(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-press"] && !Shopify.designMode) return;
  try {
    
  //slider
    if(window.innerWidth > 550) {
       $('.press-list-item--slider').slick({
      speed: 400,
      slidesToShow: 3,
      infinite:true,
      arrows:true,
     
      });
    } else {

       $('.press-list-item--slider').slick({
      speed: 400,
      slidesToShow: 1,
      infinite:true,
      arrows:true,
      dots:true
      });
    }
//dfg

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-footer-full"] && !Shopify.designMode) return;
  try {
    

 
        
  var actCallback = async function (response) {
    
       window.recToken = response
           
         
  
  
        
  
        
  };
        
  var expCallback = function() {
        
 
        
  };
        
        
  var onloadCallback = function () {
        
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
        
      'sitekey' : "6LfF8qckAAAAAOr7kuvmHDPJ0u5hsSBfMWrsnRiD", // Sitekey, Retrieving from reCaptcha
        
      'theme': "light",
        
      'callback' : actCallback,
        
      'expired-callback': expCallback,
        
    });
        
  } 
  window.onloadCallback = onloadCallback;



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  //asd
  
  // $('.more-btn-press').on('click', function(){
    
  //   let nxtPage = parseInt(document.getElementsByClassName('main-blog')[0].dataset['page'])+1;
  //   document.getElementsByClassName('main-blog')[0].dataset['page'] = String(nxtPage);
  //   //fds
  // $.ajax({
  //   url: `https://elementeight.com/blogs/press?page=${nxtPage}`,
  //   type: 'GET',
  //   dataType: 'html',
  //   success: function(responseHTML){
  
    
  //     if($(responseHTML).find('.press-item-list')[0].children.length === 0){
  //        document.getElementsByClassName('more-btn-press')[0].style.display = 'none';
  //     } else {
  //         $('.press-item-list').append($(responseHTML).find('.press-item-list').html());
  //     }
  //   },
  //   complete: function() {
      
  //   }
  // })
  // })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    let btnOpen = document.getElementsByClassName('benefits-btn-open');
  const items = document.getElementsByClassName('benefits-header');
 let ingridList = document.getElementsByClassName('benefits-ingredients-main')[0];
 
  Array.from(items).forEach(item => {
     item.addEventListener('click', (e) => {
       if(window.innerWidth <= 450){
         
      
       let target = e.target;
       
       if(e.target.className !== 'benefits-header'){
         target = e.target.parentNode;
       }
        
       
       let content = target.nextElementSibling;
            console.log(ingridList)
      console.log(content)
       content.classList.toggle('open');
       target.children[1].classList.toggle('open');
   
       ingridList.classList.remove('open') 
        }
     })
  })
  let btnOpen1 = document.getElementsByClassName('benefits-btn-open');
 
   btnOpen1[0].addEventListener('click', (e) => {
        ingridList.classList.toggle('open');
      
        
  
     console.log(e.target)
        if(e.target.innerHTML.trim() === "SEE ALL INGREDIENTS"){
           e.target.innerHTML = "CLOSE"
         } else{
           e.target.innerHTML = "SEE ALL INGREDIENTS"
         }
  
  
       
      })
  //dsfsd333k3re1
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-page"] && !Shopify.designMode) return;
  try {
    



  if(window.innerWidth <= 550){
    $('.reviews-main__reviews-list').slick({
      speed: 400,
      slidesToShow: 1,
      infinite:false,
      arrows:false,
      initialSlide:1,
      });
     $('.reviews-main__reviews-list').on('swipe', function(event, slick, direction){
       console.log(slick);
       if(slick.currentSlide === 2 &&  slick.slideCount <= 10){
         
           numberOfPage++;
           getReviews(false, true);
          
       }
        if(slick.currentSlide === 12 && slick.slideCount <= 20 && slick.slideCount > 10 ){
           
           numberOfPage++;
           getReviews(false, true);
          
       }
        if(slick.currentSlide === 22 && slick.slideCount <= 30 && slick.slideCount > 20){
           
           numberOfPage++;
           getReviews(false, true);
          
       }
        if(slick.currentSlide === 32 && slick.slideCount <= 40 && slick.slideCount > 30){
           
           numberOfPage++;
           getReviews(false, true);
          
       }
        if(slick.currentSlide === 42 && slick.slideCount <= 50 && slick.slideCount > 40){
           
           numberOfPage++;
           getReviews(false, true);
          
       }
  // left12922kdf3433we232332
});
      $(window).resize(function(){
        $('.reviews-main__reviews-list')[0].slick.refresh();
      });

    
    
  }
  




  } catch(e) { console.error(e); }
})();
})();
